import { render } from "./CircularProgressBar.vue?vue&type=template&id=5d2a9f17&scoped=true&ts=true"
import script from "./CircularProgressBar.vue?vue&type=script&lang=ts"
export * from "./CircularProgressBar.vue?vue&type=script&lang=ts"

import "./CircularProgressBar.vue?vue&type=style&index=0&id=5d2a9f17&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2a9f17"]])

export default __exports__